<template>
    <nav class="navbar">
        <div class="navbar-brand brand-small">
            <router-link v-if="isStaff" :to="{ name: 'dashboard' }">
                <icon-svg
                    v-if="isFullMenu"
                    :height="30"
                    :width="122"
                    class="white"
                    iconName="sellsy"
                    viewBox="0 0 118 28"
                >
                    <icon-sellsy-text />
                </icon-svg>
                <icon-svg
                    v-else
                    :height="26"
                    :width="36"
                    class="white"
                    iconName="sellsy"
                    viewBox="0 0 35 24"
                >
                    <icon-sellsy-cloud />
                </icon-svg>
            </router-link>
            <a v-else :href="urlHome">
                <icon-svg
                    v-if="isFullMenu"
                    :height="30"
                    :width="122"
                    class="white"
                    iconName="sellsy"
                    viewBox="0 0 118 28"
                >
                    <icon-sellsy-text />
                </icon-svg>
                <icon-svg
                    v-else
                    :height="26"
                    :width="36"
                    class="white"
                    iconName="sellsy"
                    viewBox="0 0 35 24"
                >
                    <icon-sellsy-cloud />
                </icon-svg>
            </a>
        </div>

        <div class="navbar-container">
            <!-- FAST SEARCH -->
            <slot name="search">
                <!-- <?php if ($identity->isStaff()) : ?>
                    <?= $view->render('layouts/partials/fast-search.php') ?>
                <?php endif; ?> -->
            </slot>
            <!-- FAST SEARCH FIN -->

            <div class="navbar-content">
                <ul class="nav navbar-content__actions">
                    <slot name="menu">
                        <!-- <?= $view->render('layouts/partials/menu-header.php') ?> -->
                    </slot>
                </ul>

                <div class="navbar-content__divider"></div>

                <slot name="onboardingScreen"></slot>

                <div class="navbar-content__user-container">
                    <div
                        v-if="!isStaff"
                        class="navbar-content__user--profil typographies-paragraph-medium-semibold"
                    >
                        <div>{{ fullName }}</div>
                        <div class="typographies-paragraph-small-regular">{{ corpName }}</div>
                    </div>

                    <!-- STAFF -->
                    <a v-else :href="staffUrl" class="block navbar-content__user">
                        <div
                            class="navbar-content__user--profil typographies-paragraph-medium-semibold"
                        >
                            <div>{{ fullName }}</div>
                            <div class="typographies-paragraph-small-regular">{{ corpName }}</div>
                        </div>

                        <!-- PICTURE -->
                        <div class="navbar-content__user--profil-avatar">
                            <span v-if="avatar.type === 'initials'" class="avatar">
                                {{ avatar.value }}
                            </span>
                            <div v-else class="avatar avatar-picture">
                                <img :src="avatar.value" class="pi" />
                            </div>
                        </div>
                    </a>
                </div>

                <div class="navbar-content__divider"></div>

                <div class="navbar-content__params">
                    <CompassTooltip
                        slot="reference"
                        :content="$t.__('header.Nav.menu')"
                        placement="bottom"
                        contentClass="navbar-tooltip"
                        :arrow="false"
                    >
                        <div
                            v-click-outside="hideMenu"
                            class="navbar-content__params--burger"
                            @click="toggleMenu"
                        >
                            <CompassIcon
                                icon="menu"
                                class="navbar-content__params--burger-icon"
                                :size="burgerIconSize"
                            />
                            <span
                                class="navbar-content__params--burger-label typographies-paragraph-small-regular"
                            >
                                {{ $l10n.__('Menu') }}
                            </span>
                        </div>
                    </CompassTooltip>
                    <div class="dropdown-menu dropdown-right" :class="{ isVisible: isVisible }">
                        <!-- LINK'S FIRST SECTION -->
                        <ul v-if="isStaff" class="nav pb-3">
                            <li class="px-3" data-bot="menu-burger__setting">
                                <router-link to="/settings">
                                    {{ $l10n.__('Réglages') }}
                                </router-link>
                            </li>
                            <li class="px-3">
                                <a
                                    :class="canAccessActionHistory ? 'cpointer' : 'grey cdefault'"
                                    @click="loadHistory"
                                >
                                    {{ $l10n.__('Historique des actions') }}
                                </a>
                            </li>
                            <li class="px-3">
                                <a
                                    :class="{ 'grey cdefault': !isAdmin }"
                                    :href="!isAdmin ? 'javascript:;' : legacyUrl"
                                    @click="showErrorNotAdmin"
                                >
                                    {{ $l10n.__('Modules') }}
                                </a>
                            </li>
                            <li class="px-3">
                                <a href="https://marketplace.sellsy.com/" target="_blank">
                                    {{ $l10n.__('Marketplace') }}
                                </a>
                            </li>
                            <li v-if="automationsAllowed" class="menu-burger">
                                <a href="/automations/listing">
                                    <span class="new">
                                        {{ $l10n.__('Automatisation') }}
                                        <CompassFlag :label="labels.new" size="small" />
                                    </span>
                                </a>
                            </li>
                        </ul>
                        <ul v-else class="nav pb-3">
                            <li class="px-3">
                                <a :href="extProfile">
                                    {{ $l10n.__('Mon compte') }}
                                </a>
                            </li>
                        </ul>
                        <!-- LINK'S FIRST SECTION FIN -->

                        <!-- FORMULE -->
                        <div v-if="isStaff" class="notifs bt-1 bb-1 pt-3 pb-3 mx-3">
                            <template v-if="canal === 'direct'">
                                <template v-if="accountLevel === 'trial'">
                                    <p class="m-0">
                                        <span class="info-label">
                                            {{ $l10n.__('Compte en essai jusqu’au') }}
                                        </span>
                                        <span class="info-value">
                                            {{ trialDeadline }}
                                        </span>
                                    </p>
                                    <p
                                        v-if="
                                            isSelfServiceAvailable && isSelfServiceVersioningAllowed
                                        "
                                        class="acenter m-O"
                                    >
                                        <CompassButton
                                            :label="$t.__('header.Nav.subscribe')"
                                            @click="subUrl"
                                        />
                                    </p>
                                </template>
                                <template v-else>
                                    <template v-if="isSamPlan">
                                        <p v-if="isselfserviceavailable" class="acenter m-0 pb-2">
                                            <CompassButton
                                                :label="$t.__('header.Nav.manage_subscription')"
                                                type="secondary"
                                                :disabled="enabledButtonSubscriptionV3"
                                                @click="manageSubscription"
                                            />
                                        </p>
                                        <p class="acenter m-0">
                                            <span class="info-label">
                                                {{ $l10n.__('Expire le :') }}
                                            </span>
                                            <span class="info-value">{{ planExpireTime }}</span>
                                        </p>
                                    </template>
                                    <template v-else>
                                        <p class="m-0">
                                            <span class="info-label">
                                                {{ $l10n.__('Formule :') }}
                                            </span>
                                            {{ planInfos.label }}
                                        </p>
                                        <p class="m-0">
                                            <span class="info-label">
                                                {{ $l10n.__('Expire le :') }}
                                            </span>
                                            <span class="info-value">{{ planExpireTime }}</span>
                                        </p>
                                    </template>
                                </template>
                            </template>
                        </div>
                        <!-- FORMULE FIN -->

                        <!-- LINK'S SECOND SECTION -->
                        <ul v-if="isStaff" class="nav py-3">
                            <li class="px-3">
                                <a
                                    :href="`https://help.sellsy.com/hc/?lang=${lang}`"
                                    target="_blank"
                                >
                                    {{ $l10n.__('Aide') }}
                                </a>
                            </li>
                            <li class="px-3">
                                <a
                                    href="https://go.sellsy.com/academy?utm_source=saas&utm_medium=menu"
                                    target="_blank"
                                >
                                    {{ $l10n.__('Sellsy Academy') }}
                                </a>
                            </li>
                            <li v-if="accountLevel === 'gold'" class="navbar__menu--list">
                                <a :href="accountPrefsUrl">
                                    {{ $l10n.__('Espace parrainage') }}
                                </a>
                                <CompassIcon icon="gift" />
                            </li>
                        </ul>
                        <!-- LINK'S SECOND SECTION FIN -->

                        <div v-if="showRecapButton" class="recap-button__wrapper">
                            <button class="recap-button" @click="goToRecap">
                                <span class="recap-button__label">{{ $t.__('recap.button') }}</span>
                                <img
                                    src="/ressources/logged/img/illustrations/recap2024/shape-recap-no-anim.svg"
                                    width="110"
                                />
                            </button>
                        </div>

                        <!-- LOGOUT BTN -->
                        <div class="acenter mb-3">
                            <CompassButton :label="$t.__('header.Nav.logout')" @click="logout" />
                        </div>
                        <!-- LOGOUT BTN FIN -->

                        <!-- CORP AVAILABLE FOR LOGIN -->
                        <slot name="account"></slot>
                        <!-- END CORP AVAILABLE FOR LOGIN -->
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import { createNamespacedHelpers } from 'vuex';
import IconSvg from 'vcomponents/icons/IconSvg.vue';
import IconSellsyText from 'vcomponents/icons/IconSvgLogoSellsyText.vue';
import IconSellsyCloud from 'vcomponents/icons/IconSvgLogoSellsyCloud.vue';
import Feature from 'Services/Feature';

const corpMapState = createNamespacedHelpers('corp').mapState;
const userMapState = createNamespacedHelpers('user').mapState;

export default {
    components: {
        IconSvg,
        IconSellsyCloud,
        IconSellsyText,
    },
    props: {
        avatar: {
            type: Object,
            required: true,
        },
        isadmin: {
            type: Boolean,
            required: true,
        },
        canaccessactionhistory: {
            type: Boolean,
            required: true,
        },
        legacyurl: {
            type: String,
            required: true,
        },
        urlhome: {
            type: String,
            required: true,
        },
        extprofile: {
            type: String,
            required: true,
        },
        trialdeadline: {
            type: String,
            required: true,
        },
        isselfserviceavailable: {
            type: Boolean,
            required: true,
        },
        planbuilderurl: {
            type: String,
            required: true,
        },
        planinfo: {
            type: Object,
            required: true,
        },
        issamplan: {
            type: Boolean,
            required: true,
        },
        cartformurl: {
            type: String,
            required: true,
        },
        planexpiretime: {
            type: String,
            required: true,
        },
        lang: {
            type: String,
            required: true,
        },
        accountprefsurl: {
            type: String,
            required: true,
        },
        logouturl: {
            type: String,
            required: true,
        },
        staffurl: {
            type: String,
            required: true,
        },
        pricingversion: {
            type: String,
            required: true,
        },
        hasupcomingvalidatedcart: {
            type: Boolean,
            required: false,
        },
    },
    data() {
        return {
            isFullMenu: true,
            isVisible: false,
            burgerIconSize: '',
            labels: {
                new: this.$l10n.__('Nouveau'),
            },
        };
    },
    computed: {
        ...corpMapState({
            accountLevel: 'accountLevel',
            corpName: 'name',
            canal: 'canal',
        }),
        ...userMapState(['forename', 'name', 'type']),
        fullName() {
            return `${this.forename} ${this.name}`;
        },
        isStaff() {
            return this.type === 'staff';
        },
        isAdmin() {
            return this.isadmin;
        },
        isGuest() {
            return this.type === 'thirdcontact';
        },
        canAccessActionHistory() {
            return this.canaccessactionhistory;
        },
        legacyUrl() {
            return this.legacyurl;
        },
        urlHome() {
            return this.urlhome;
        },
        extProfile() {
            return this.extprofile;
        },
        trialDeadline() {
            return this.trialdeadline;
        },
        isSelfServiceAvailable() {
            return this.isselfserviceavailable;
        },
        planBuilderUrl() {
            return this.pricingversion === '4'
                ? this.$router.resolve({
                      name: 'sam.v4.client.form.plan',
                      params: { id: 'new' },
                  }).href
                : this.planbuilderurl;
        },
        planInfos() {
            return this.planinfo;
        },
        isSamPlan() {
            return this.issamplan;
        },
        cartFormUrl() {
            if (this.pricingversion >= '4') {
                return '/?_f=accountPreferences&action=subscription';
            }

            if (this.hasupcomingvalidatedcart) {
                return '#';
            }

            return this.cartformurl;
        },
        planExpireTime() {
            return this.planexpiretime;
        },
        accountPrefsUrl() {
            return this.accountprefsurl;
        },
        logoutUrl() {
            return this.logouturl;
        },
        staffUrl() {
            return this.staffurl;
        },
        isSelfServiceVersioningAllowed() {
            return parseInt(this.pricingversion) < 4;
        },
        enabledButtonSubscriptionV3() {
            return this.hasupcomingvalidatedcart && this.pricingversion === '3';
        },
        automationsAllowed() {
            return Feature.isEnabled('automations') && this.isAdmin;
        },
        showRecapButton() {
            return this.isAdmin && Feature.isEnabled('recap-2024');
        },
    },
    created() {
        EventBus.$on('main-menu:on-size-changed', ({ isFullMenu }) => {
            this.isFullMenu = isFullMenu;
        });
        this.setBurgerSize();
        window.addEventListener('resize', this.resizeScreen);
    },

    destroyed() {
        // eslint-disable-next-line no-undef
        EventBus.$off('main-menu:on-size-changed');
        window.removeEventListener('resize', this.resizeScreen);
    },
    methods: {
        resizeScreen: _.debounce(function () {
            this.setBurgerSize();
        }, 200),

        setBurgerSize() {
            this.burgerIconSize = document.body.clientWidth < '1280' ? 'small' : 'medium';
        },
        loadHistory() {
            this.canAccessActionHistory
                ? window.LogEngine.loadPopup(
                      'dashboard',
                      '0',
                      this.$l10n.__('Historique des actions du compte'),
                  )
                : Push.error(this.$l10n.__(`Vous n'avez pas les droits nécessaires`));
        },
        /**
         * Toggles dropdown menu visibilty
         *
         * @returns void
         */
        toggleMenu() {
            this.isVisible = !this.isVisible;
        },
        /**
         * Hides dropdown menu when user clicks outside
         *
         * @returns void
         */
        hideMenu() {
            this.isVisible = false;
        },

        /**
         * Message that appears if user is not an admin
         *
         * @returns void
         */

        showErrorNotAdmin() {
            !this.isAdmin
                ? Push.error(this.$l10n.__(`Vous n'avez pas les droits nécessaires`))
                : null;
        },

        manageSubscription() {
            return goToUrl(this.cartFormUrl);
        },

        logout() {
            try {
                window.Intercom('shutdown');
            } catch (e) {
                // Intercom not loaded
            }
            return goToUrl(this.logouturl);
        },
        subUrl() {
            return goToUrl(this.planBuilderUrl);
        },
        goToRecap() {
            this.$router.push({ name: 'recap2024' });
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.navbar {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;

    min-width: 1024px !important;
    min-height: 60px;

    &__menu {
        &--list {
            display: flex;
            align-items: center;
            color: var(--colors-common-text-standard-default);
            padding: 0 var(--spacing-3);

            &:hover {
                color: var(--colors-common-text-standard-active);
            }
        }
    }
}

::v-deep {
    .navbar {
        &-brand {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 180px;

            background-color: var(--colors-common-background-darkest-default);

            &.brand-small {
                width: 64px;
            }

            a {
                display: block;
            }
        }

        &-container {
            position: relative;

            display: flex;
            flex-flow: row-reverse wrap;
            align-items: center;
            justify-content: space-between;
            flex: 1;

            background-color: var(--colors-common-background-default);
            box-shadow: var(--box-shadows-x-small);

            .navbar-content {
                display: flex;
                flex-direction: row;
                gap: var(--spacing-3);
                align-items: center;
                justify-content: flex-end;
                padding: 0 var(--spacing-1);

                &__divider {
                    width: 1px;
                    height: 48px;
                    background-color: var(--colors-common-border-lighter);

                    @media screen and (width < 1280px) {
                        height: 40px;
                    }
                }

                &__actions {
                    display: flex;
                    flex-flow: row nowrap;
                    gap: var(--spacing-1);
                    align-items: flex-start;

                    margin: 0;

                    &--item {
                        position: relative;

                        &-link {
                            display: flex;
                            flex-direction: column;
                            gap: var(--spacing-0);
                            align-items: center;

                            padding: var(--spacing-0);

                            border-radius: 4px;

                            &:hover {
                                background-color: var(--colors-common-background-primary-hover-alt);
                            }

                            .navbar-content__actions--item-icon {
                                font-size: var(--font-size-20);
                                color: var(--colors-common-text-standard-default);

                                @media screen and (width < 1280px) {
                                    font-size: var(--font-size-16);
                                }
                            }

                            .navbar-content__actions--item-label {
                                color: var(--colors-common-text-standard-caption);
                                display: none;
                            }

                            .icon-objectives,
                            .icon-activities {
                                font-weight: var(--font-weights-proxima-nova-0);
                            }

                            @media screen and (width < 1280px) {
                                width: 24px;
                                height: 24px;
                            }

                            @media screen and (width >= 1280px) and (width < 1440px) {
                                width: 28px;
                                height: 28px;
                            }
                        }

                        .dropdown-menu {
                            min-width: 160px;

                            .contentSubmenu {
                                padding: var(--spacing-3) 0;
                                border-radius: 4px;
                                box-shadow: var(--box-shadows-x-small);
                            }
                        }

                        &:hover {
                            .dropdown-menu {
                                display: block;
                            }
                        }
                    }
                }

                &__user {
                    display: flex;
                    flex-direction: row;
                    gap: var(--spacing-3);
                    align-items: flex-start;
                    justify-content: center;

                    padding: var(--spacing-1);

                    border-radius: 4px;

                    &:hover {
                        background-color: var(--colors-common-background-primary-hover-alt);
                    }

                    &-container {
                        flex-shrink: 0;
                    }

                    &--profil {
                        color: var(--colors-common-text-standard-default);
                        text-align: right;

                        & > div {
                            text-overflow: ellipsis;
                            max-width: 160px;
                            overflow: hidden;
                            white-space: nowrap;
                        }

                        & > span {
                            color: var(--colors-common-text-standard-caption);
                        }

                        @media screen and (width < 1280px) {
                            font-size: var(--font-size-12);
                            line-height: var(--line-heights-16);
                        }
                    }

                    @media screen and (width <= 1439px) {
                        gap: var(--spacing-1);
                        padding: var(--spacing-0);
                    }
                }

                &__params {
                    position: relative;

                    &--burger {
                        cursor: pointer;

                        display: flex;
                        flex-direction: column;
                        gap: var(--spacing-0);
                        align-items: center;

                        padding: var(--spacing-0);

                        border-radius: 4px;

                        &:hover {
                            background-color: var(--colors-common-background-primary-hover-alt);
                        }

                        &-icon {
                            font-size: var(--font-size-20);
                            color: var(--colors-common-text-standard-default);

                            @media screen and (width < 1280px) {
                                font-size: var(--font-size-16);
                            }
                        }

                        &-label {
                            color: var(--colors-common-text-standard-caption);
                            display: none;
                        }
                    }

                    .dropdown-menu {
                        width: 240px;

                        .menu-burger {
                            padding: 0 var(--spacing-3);
                        }
                    }
                }

                @media screen and (width < 1280px) {
                    gap: var(--spacing-1);
                }
            }
        }
    }
}
.recap-button {
    background: linear-gradient(
                var(--colors-common-background-darkest-default),
                var(--colors-common-background-darkest-default)
            )
            padding-box,
        linear-gradient(241.84deg, #7f95fe -2.56%, #3a10f4 25.24%, #01002d 92.79%) border-box;
    border: 3px solid transparent;
    border-radius: 50px;
    cursor: pointer;
    display: block;
    height: 33px;
    overflow: hidden;
    position: relative;
    transition: all ease-in-out 200ms;
    width: 100%;

    img {
        left: 0;
        position: absolute;
        top: -20px;
        transform: translate(-15%, 0) scale(0.73);
        transition: all ease-in-out 200ms;
    }

    &:hover {
        background: linear-gradient(
                    var(--colors-common-background-darkest-default),
                    var(--colors-common-background-darkest-default)
                )
                padding-box,
            linear-gradient(113.37deg, #7f95fe 37.92%, #3a10f4 59.5%, #01002d 111.96%) border-box;
        img {
            transform: translate(0, -10%) scale(1);
        }
    }

    &__label {
        color: var(--colors-sellsy-yellow-100);
        font-family: Patron, sans-serif;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 1px;
        line-height: 1.1;
        position: relative;
        text-transform: uppercase;
        z-index: 1;
    }

    &__wrapper {
        border-bottom: 1px solid var(--colors-common-border-default);
        border-top: 1px solid var(--colors-common-border-default);
        margin: 0 16px 16px;
        padding: 16px 0;
    }
}
</style>

<style lang="scss">
html > body div.global {
    min-width: 1024px !important;
}

.navbar {
    &-tooltip {
        z-index: 20001 !important;
    }

    .dropdown-menu {
        position: absolute;
        top: calc(100% - 2px);
        right: 0;
        left: auto;

        display: none;

        padding: var(--spacing-3) 0;

        background-color: var(--colors-common-background-default);
        border-radius: 4px;
        box-shadow: var(--box-shadows-x-small);

        &.isVisible {
            display: block;
        }

        ul {
            margin: 0;

            li {
                &:hover {
                    background-color: var(--colors-common-background-primary-hover-alt);
                }

                a {
                    display: block;
                    padding: 6px var(--spacing-1);
                    line-height: var(--line-heights-20);
                    color: var(--colors-common-text-standard-default);

                    &:hover {
                        color: var(--colors-common-text-standard-active);
                    }

                    .new {
                        display: flex;
                        align-items: center;
                        gap: var(--spacing-1);
                    }
                }
            }
        }
    }
}
</style>
